import { render, staticRenderFns } from "./ItensTreeEditor.vue?vue&type=template&id=2dfe9bd4&scoped=true"
import script from "./ItensTreeEditor.vue?vue&type=script&lang=js"
export * from "./ItensTreeEditor.vue?vue&type=script&lang=js"
import style0 from "./ItensTreeEditor.vue?vue&type=style&index=0&id=2dfe9bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe9bd4",
  null
  
)

export default component.exports